import { catalogCenterEn } from "./catalog-center";
import { centersCenterEn } from "./centers-center";
import { loginCenterEn } from "./login-center";
import { platformAdminApplications } from "./platform-admin-applications";
import { platformAdminAssets } from "./platform-admin-assets";
import { platformAdminCommon } from "./platform-admin-common";
import { platformAdminDashboard } from "./platform-admin-dashboard";
import { platformAdminExecution } from "./platform-admin-execution";
import { platformAdminIdentity } from "./platform-admin-identity";
import { platformAdminNavigation } from "./platform-admin-navigation";
import { platformAdminPortalManagement } from "./platform-admin-portal-management";
import { platformAdminValues } from "./platform-admin-values";

export const platformAdmin = {
  title: "Platform Admin",
  shellSubtitle: "Platform Control Plane",
  links: platformAdminNavigation.links,
  menu: platformAdminNavigation.menu,
  common: platformAdminCommon,
  values: platformAdminValues,
  dashboard: platformAdminDashboard,
  portalManagement: platformAdminPortalManagement,
  applications: platformAdminApplications,
  assets: platformAdminAssets,
  execution: platformAdminExecution,
  identity: platformAdminIdentity,
  centers: centersCenterEn,
  catalog: catalogCenterEn,
  login: loginCenterEn,
} as const;
